module.exports = __webpack_public_path__ + "img/get-help.00fd037a.svg";